import {gql} from '@apollo/client';
import {DocumentNode} from 'graphql';

import FragmentWrapper from 'graphql-client/FragmentWrapper';
import {GraphQLAnalyticsQuerySpecFragment} from 'insights/analytics-queries/data/AnalyticsQueryGQLRESTConverters';
import {AnalyticsVisualizationFragment} from 'insights/analytics-visualizations/AnalyticsVisualizationConstants';

import {AnalyticsQuery} from './__generated/AnalyticsQuery';

// This fragment expands on the GraphQLAnalyticsQuerySpec fragment by capturing all the needed query details
// from the server to render a query on the ui by adding additional information for its child nodes, such as the
// visualization information.
const ANALYTICS_QUERY_FRAGMENT: DocumentNode = gql`
  fragment AnalyticsQuery on AnalyticsQueryNode {
    ...GraphQLAnalyticsQuerySpec
    createdAt
    creator {
      id
      handle
      name
    }
    modifiedAt
    visualization {
      ...AnalyticsVisualization
    }
  }
  ${AnalyticsVisualizationFragment.fragment}
  ${GraphQLAnalyticsQuerySpecFragment.fragment}
`;

export const AnalyticsQueryFragment: FragmentWrapper<AnalyticsQuery> = {
  fragment: ANALYTICS_QUERY_FRAGMENT,
  fragmentName: 'AnalyticsQuery',
};
